import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import FileUpload from './FileUpload'
import { axiosInstance } from '../../../../const/axiosInstance'
import styles from './edit.module.css'

export default function EditRent({add}) {
        const [image, setImage] = useState('')
        const navigate = useNavigate()
    
        const addImage = async () => {
          await axiosInstance.post(`/admin/rent/add`, {image})
          navigate("/dashboard/rent")
        }
    
      return (
        <div className={styles['edit-part']}>
             <div className={styles['upload']}>
                <p>Ավելացնել նկար։ </p>
                <FileUpload setImage={setImage}/>  
                <input disabled={true} placeholder='ֆայլ' value={image}/>
            </div>
            <div className={styles['btn-div']}>
              {image ?
                <Link><button className={`${styles['btn']} ${styles['confirm']}`} onClick={addImage}>Հաստատել</button></Link>
                : <button disabled className={`${styles['btn']} ${styles['confirm']}`}>Հաստատել</button>
              }
                <Link to='/dashboard/rent'><button className={`${styles['btn']} ${styles['cancel']}`}>Չեղարկել</button></Link>
            </div>
        </div>
      )
    }

